import React from "react";
import { QIModal, QIModalBody, QIButton } from "../../../components";
import { tHelper } from "../../../shared/translation";

export const MPSharedDeleteModal = ({ entityName, itemName, onHide, show, onDelete }) => {
  const t = tHelper.get("shared");

  return (
    <QIModal show={show} scrollable={true} size="small">
      <QIModalBody>
        <h5 className="text-center">
          <strong>{t?.common?.confirmation_alert}</strong>
        </h5>
        <p className="text-center">
          {t?.common?.delete_text} {entityName} <strong>{itemName}</strong>
        </p>
        <p className="text-center">{t?.common?.are_you_sure}</p>
        <div className="flex justify-center">
          <QIButton onClick={onHide}>{t?.button?.no}</QIButton>
          <QIButton onClick={onDelete} className="primary">
            {t?.button?.yes}
          </QIButton>
        </div>
      </QIModalBody>
    </QIModal>
  );
};
